import { inject as b, ref as v, watch as P, computed as m, unref as r, provide as F, nextTick as w } from "vue";
import { useEventListener as R, onClickOutside as h, unrefElement as E } from "./design-system.es125.js";
import { useFocusTrap as q } from "./design-system.es295.js";
import { usePopper as B } from "./design-system.es119.js";
import D from "./design-system.es146.js";
import { bottomStart as x, bottomEnd as S, topStart as j, topEnd as y } from "./design-system.es294.js";
import z from "./design-system.es296.js";
function A(l) {
  const {
    id: o,
    isOpen: e,
    isControlled: s,
    triggerExternal: t
  } = l, n = v(null);
  function a(p) {
    n.value = p;
  }
  t && P(t, a, { immediate: !0 });
  function c() {
    s.value || (e.value ? e.value = !1 : e.value = !0);
  }
  R(n, "click", c);
  const u = m(() => ({
    "aria-controls": r(o),
    "aria-haspopup": r(e),
    ref: r(t) ? void 0 : a
  })), i = m(() => ({
    ...u.value,
    isOpen: r(e),
    attrs: u.value
  }));
  return {
    trigger: n,
    triggerProps: i
  };
}
function L(l) {
  const {
    id: o,
    isOpen: e,
    arrow: s
  } = l, t = v(null);
  function n(c) {
    t.value = c;
  }
  const a = m(() => ({
    id: r(o),
    ref: n,
    isOpen: r(e),
    arrow: r(s),
    role: "menu"
  }));
  return {
    menu: t,
    menuProps: a
  };
}
function $(l) {
  const {
    isOpen: o,
    isControlled: e,
    trigger: s,
    menu: t,
    position: n,
    arrow: a,
    offset: c,
    onRequestClose: u
  } = l, { isRtl: i } = D(), p = m(() => r(i) ? r(n) === x ? S : r(n) === j ? y : x : r(n));
  function O() {
    if (o.value) {
      if (e.value) {
        setTimeout(u);
        return;
      }
      o.value = !1;
    }
  }
  const g = {
    trigger: s,
    menu: t,
    isOpen: o,
    position: p,
    arrow: a,
    offset: c
  }, { popper: C } = B(g), { activate: d, deactivate: M } = q(t, {
    initialFocus: () => E(t),
    fallbackFocus: () => E(s),
    allowOutsideClick: !0,
    escapeDeactivates: (f) => !f.target.value,
    onPostDeactivate: () => {
      e.value ? u() : o.value = !1;
    }
  });
  return P(o, (f) => {
    f ? w(d) : w(M);
  }), h(
    t,
    O,
    { ignore: [s] }
  ), {
    popper: C
  };
}
function U(l) {
  const {
    trigger: o,
    isOpen: e,
    position: s,
    dense: t,
    arrow: n,
    offset: a,
    onRequestClose: c = () => {
    }
  } = l, u = v(`menu-${z()}`), i = v(!1);
  P(e, (T) => {
    i.value = T;
  }, { immediate: !0 });
  const p = m(() => r(e) === !0 || r(e) === !1);
  function O() {
    i.value = !1;
  }
  const { trigger: g, triggerProps: C } = A({
    id: u,
    isOpen: i,
    isControlled: p,
    triggerExternal: o
  }), { menu: d, menuProps: M } = L({
    id: u,
    isOpen: i,
    arrow: n
  }), { popper: f } = $({
    isOpen: i,
    isControlled: p,
    trigger: g,
    menu: d,
    position: s,
    arrow: n,
    offset: a,
    onRequestClose: c
  }), k = {
    isOpen: i,
    isControlled: p,
    id: u,
    trigger: g,
    menu: d,
    popper: f,
    dense: t,
    triggerProps: C,
    menuProps: M,
    close: O
  };
  return F("dsMenu", k), k;
}
function V() {
  return b("dsMenu");
}
export {
  V as useMenu,
  U as useMenuProvider
};
//# sourceMappingURL=design-system.es293.js.map
